import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import { checkPermission } from "../../app/utils/helpers";
import { NumberInput } from "../../components/inputs/NumberInput";
import { SelectInput } from "../../components/inputs/Select";
import { ThemeButton } from "../../components/buttons/ThemeButton";
import { config } from "../../app/utils/config.js";
import { updateTeamSettings } from "./settingsSlice";
import { updateAllTeamsSettings } from "../../components/teams/teamsSlice.js";
import styles from "./Settings.module.css";

export default function ClientSettingsTab() {

  const dispatch = useDispatch()

  const teams = useSelector((state) => state.teams.list)

  const [selectedTeam, setSelectedTeam] = useState()
  const [newTeamSettings, setNewTeamSettings] = useState()

  useEffect(() => {
    if (!selectedTeam && teams[0]) {
      setSelectedTeam(teams[0])
      setNewTeamSettings(teams[0].settings)
    }
  }, [dispatch, teams])

  const handleTeamChange = (selectedOption) => {
    setSelectedTeam(selectedOption)
    setNewTeamSettings(selectedOption.settings)
  }

  const handleTeamParameterChange = (event) => {
    let settings = newTeamSettings || selectedTeam.settings
    let newSettings = settings.map(s => { return { ...s } })
    for (const key in newSettings) {
      if (newSettings[key].id == event.target.id) {
        newSettings[key].value = event.target.value
      }
    }
    setNewTeamSettings(newSettings)
  }

  const handleTeamParameterSave = () => {
    let params = { idTeam: selectedTeam.value, fields: [] }
    newTeamSettings.map(s => {
      params.fields.push({
        id: s.id,
        value: s.type == 'number' ? Number(s.value) : s.value
      })
    })
    dispatch(updateTeamSettings(params))
    dispatch(updateAllTeamsSettings({ id: selectedTeam.id, settings: newTeamSettings }))
    setSelectedTeam({ ...selectedTeam, settings: newTeamSettings })
  }

  return (
    <Row className="m-0">
      <Col xxl={1}>
      </Col>
      <Col xxl={8} className="d-flex align-content-center">
        <div className={styles.menuContent}>
          <Row className="p-2">
            <Row>
              <Col
                md={4}
                className="d-flex justify-content-start align-items-center p-2 ps-4">
                <label className={styles.menuHeaderTitle}>
                  <Langs str="CLIENT" />
                </label>
              </Col>
              <Col md={8} className="p-2 m-0">
                <SelectInput
                  key={"team_selector"}
                  value={selectedTeam && selectedTeam.id}
                  onChange={handleTeamChange}
                  options={teams} />
              </Col>
            </Row>
            {newTeamSettings && newTeamSettings.map((setting) => (
              <Row key={`ITEM_${setting.id}`}>
                <Col
                  xl={9}
                  className="d-flex justify-content-start align-items-center p-2 ps-4">
                  <label className={styles.menuTitle}>
                    <Langs str={setting.label} />
                  </label>
                </Col>
                <Col
                  xl={3}
                  className="d-flex justify-content-end align-items-center p-2 m-0">
                  <NumberInput
                    name={setting.label}
                    min={setting.min || 0}
                    id={setting.id}
                    data-key={setting.value}
                    // disableKeyboard = {true}
                    max={setting.max || 999}
                    onChange={handleTeamParameterChange}
                    value={setting.value}
                  />
                </Col>
              </Row>
            ))}
            {checkPermission(config.scopes.shifts, config.permissionTypes.edit) && <Row>
              <Col
                xl={4}
                className="d-flex justify-content-start align-items-center p-2 ps-4"
              ></Col>
              <Col
                xl={4}
                className="d-flex justify-content-center align-items-center p-2 m-0 mt-3">
                {newTeamSettings && JSON.stringify(newTeamSettings) != JSON.stringify(selectedTeam.settings) && <ThemeButton
                  title="SAVE"
                  active={true}
                  onClick={handleTeamParameterSave}
                ></ThemeButton>}
              </Col>
            </Row>}
          </Row>
        </div>
      </Col>
    </Row>
  )
}
